import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { svgIcons } from "../../../../style/fonts/SvgIcons";
import RecentProjectTasks from "../RecentProjectTask";
import CompletedProjectTasks from "../CompletedProjectTasks";
import TasksSidebar from "./TasksSidebar";
import ProjectTasksSidebar from "./TasksSidebar";
import { useGetAllProjectTasksQuery, useGetProjectLookupsQuery } from "../../../../services/EndPointsApis";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const ProjectTasks = ({ projectLookups, projectId }: any) => {

    const [selectedId, setselectedId] = useState<any[]>([]);
    const disable = selectedId?.length > 1 || selectedId?.length === 0 || selectedId?.length === null || selectedId?.length === undefined;
    const [activityTogglePopup, setActivityTogglePopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const params = useParams()

    // const projectId = params?.projectId
    const ProjectId = projectId;

    //All Project Tasks
    const { data: getallpTasks, refetch } = useGetAllProjectTasksQuery({ ProjectId: ProjectId });

    const handleAddNotes = () => {
        setActivityTogglePopup(true);
        setIsEditing(false);
    };
    const handleEditNotes = () => {
        setActivityTogglePopup(true);
        setIsEditing(true)
    };

    useEffect(() => {
        refetch()
    }, [])

    return (
        <>
            <ProjectTasksSidebar selectedId={selectedId} refetch={refetch} projectLookups={projectLookups} setActivityTogglePopup={setActivityTogglePopup} activityTogglePopup={activityTogglePopup} isEditing={isEditing} setIsEditing={setIsEditing} />
            <div className="row" >
                <div className="col-md-12">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col sm={12}>
                                <div className="card card-css">
                                    <div className="card-body p-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <Nav variant="pills" className="flex">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first">General </Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second">Assigned</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </div>
                                            <div className="d-flex gap-3 align-items-center">
                                                <button className="mb-0 btn btn-trasnparent border-0" disabled={selectedId === null || undefined || selectedId?.length === 0} onClick={() => handleEditNotes()}><span className="me-1">{svgIcons.updateIcon}</span>Edit</button>
                                                <button className="btn btn-primary" disabled={ !selectedId || selectedId?.length !== 0} onClick={() => handleAddNotes()}>
                                                    + New Task
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12} style={{ height: '539px', overflow: 'auto' }}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <RecentProjectTasks getallpTasks={getallpTasks} setselectedId={setselectedId} selectedId={selectedId} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <RecentProjectTasks getallpTasks={getallpTasks} setselectedId={setselectedId} selectedId={selectedId} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>

                </div>
            </div>
        </>
    );
};

export default ProjectTasks;
